import { globalKiteStatus } from "./LoginContext";

const BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');

// Bind real browser fetch
const realFetch = window.fetch.bind(window);

export async function apiFetch(path, options = {}) {
    /*if (path.includes("/kite")) {
        const kiteTradingReady =
            globalKiteStatus.readyForTrading;

        if (!kiteTradingReady) {
            return new Response(null, {
                status: 204,
                statusText: "Kite Not Ready",
                headers: { "content-type": "text/plain" }
            });
        }
    }*/

    const url  = `${BASE}${path.startsWith("/") ? path : "/" + path}`;
    const opts = { credentials: "include", ...options };

    let res;
    try {
        res = await realFetch(url, opts);
    } catch (networkErr) {
        console.error("NETWORK ERROR in apiFetch:", networkErr);

        return new Response(JSON.stringify({
            success: false,
            message: "NETWORK ERROR"
        }), {
            status: 503,
            statusText: "NETWORK ERROR",
            headers: { "content-type": "application/json" }
        });

    }

    return res;
}


export async function apiFetchJson(path, options = {}) {
    const res = await apiFetch(path, options);
    const ct  = res.headers.get('content-type') || '';
    return ct.includes('application/json') ? res.json() : res.text();
}
